export default function UnstableIcon() {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <circle cx="15" cy="15" r="15" fill="var(--orange)" opacity={0.2}/>
        <path d="M15 8C14.4598 8 13.9657 8.30667 14.0019 8.66667L14.5009 17.6667C14.5009 17.7551 14.5535 17.8399 14.6471 17.9024C14.7407 17.9649 14.8676 18 15 18C15.1324 18 15.2593 17.9649 15.3529 17.9024C15.4465 17.8399 15.4991 17.7551 15.4991 17.6667L15.9981 8.66667C16.0343 8.30667 15.5402 8 15 8Z" fill="var(--orange)" stroke="var(--orange)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15 23C15.5523 23 16 22.5523 16 22C16 21.4477 15.5523 21 15 21C14.4477 21 14 21.4477 14 22C14 22.5523 14.4477 23 15 23Z" stroke="var(--orange)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
    </svg>
  )
}
